import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27b3594d&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b3594d')) {
      api.createRecord('27b3594d', component.options)
    } else {
      api.reload('27b3594d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=27b3594d&lang=pug", function () {
      api.rerender('27b3594d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/console/centerManagement/index.vue"
export default component.exports